/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'skip-previous': {
    width: 24,
    height: 24,
    viewBox: '0 96 960 960',
    data: '<path pid="0" d="M220 816V336h80v480h-80zm520 0L380 576l360-240v480z"/>'
  }
})
